<template>
  <div>
      <h3><v-icon class="mr-2">{{icon}}</v-icon>{{text}}</h3>
  </div>
</template>

<script>
export default {
    props:{
        icon: String,
        text: String
    }
}
</script>

<style>

</style>